import { useGlobalState } from '@cpc/comment-sdk-core-comment';
import { utils } from '@cpc/comment-sdk-common';

export function useCommentScene(options = {}) {
  const { query, getStyleType } = utils;
  const contentType = getStyleType();
  const { documentMeta } = useGlobalState();
  const styleType = documentMeta.styleType;
  /**
   * videoType:
   *  micro： 小视频
   *  video：短视频
   *  infinityArticle：无限流弹窗
   */
  const videoType = query.get('videoType') || window.__TEMPLATE_COMMEMT_DATA__?.videoType

  // 无限流弹窗列表
  const infinityCommentScene = () => {
    if (videoType === 'infinityArticle') return true;
    // 兼容旧版本
    if (videoType === 'micro' || styleType == 4) return true;
  }

  // 小视频
  const microCommentScene = () => {
    return videoType === 'micro'
  }

  // 短视频
  const videoCommentScene = () => {
    return videoType === 'video'
  }

  // 有限流评论列表
  const limitedCommentScene = () => {
    return contentType || !videoType;
  };

  return {
    infinityCommentScene,
    microCommentScene,
    videoCommentScene,
    limitedCommentScene,
  };
}
